import { FE_LANG } from '@/constants/common';

export const defaultLanguage = FE_LANG.EN_US;
export const languages = Object.values(FE_LANG);
export const defaultNamespace = 'common';
export const COOKIE_NAME = 'NEXT_LOCALE';

export const namespaces = [
  'program-management',
  'account-management',
  'bulk-input',
  'bulk-input-template',
  'bulk-edit',
  'cfp-project',
  'city',
  'common',
  'currency',
  'equipment',
  'error-code',
  'error-message',
  'factor-source',
  'fd-distribution-transportation',
  'fd-product-line',
  'fd-raw-material',
  'fd-rmt',
  'fd-scenarios',
  'fugitive-emission',
  'ghg',
  'industry',
  'isic',
  'org-cfv-create-emission',
  'org-cfv-dashboard',
  'org-cfv-data-approval',
  'org-cfv-data-collection',
  'org-cfv-data-entry',
  'org-cfv-data-quality-management',
  'org-cfv-emission-identification',
  'org-cfv-list-create-project',
  'org-cfv-uncertainty-assessment',
  'process-emission-industry',
  'process-emission-raw-material-product',
  'process',
  'raw-material-product',
  'raw-material',
  'reset-password',
  'sidebar',
  'unit',
  'waste-operation-emission',
  'wmc',
  'wizard',
] as const;

export type I18nNamespaces = (typeof namespaces)[number];
